/* eslint-disable global-require */
import initWorkflow from './workflow';
import _depositLimitButtonRenderer from './deposit-limit-button';
import * as commands from './public-commands';
import * as events from './public-events';

if (process.env.NODE_ENV !== 'production') {
  _depositLimitButtonRenderer.schema = require('./deposit-limit-button.schema.json');
}

var depositLimitButton = _depositLimitButtonRenderer;
var renderers = [depositLimitButton];

export { renderers, depositLimitButton, initWorkflow, events, commands };
//# sourceMappingURL=index.js.map